import React from "react";
import { useTranslation } from "react-i18next";

export default function Hos(): JSX.Element {
    const { t } = useTranslation("assessment");
    return (
        <>
            <h3>{t("hos.title") as string}</h3>
            <p>{t("hos.list-title-1") as string}</p>
            <ul>
                <li>{t("hos.list-1.point-1") as string}</li>
                <li>{t("hos.list-1.point-2") as string}</li>
                <li>{t("hos.list-1.point-3") as string}</li>
            </ul>
            <p>{t("hos.list-title-2") as string}</p>
            <ul>
                <li>{t("hos.list-2.point-1") as string}</li>
                <li>{t("hos.list-2.point-2") as string}</li>
                <li>{t("hos.list-2.point-3") as string}</li>
                <li>{t("hos.list-2.point-4") as string}</li>
                <li>{t("hos.list-2.point-5") as string}</li>
            </ul>
            <p>{t("hos.paragraph-1") as string}</p>
            <p>{t("hos.paragraph-2") as string}<a className="bolder-text" href={t("hos.hyperlink") as string} target='_blank' rel="noopener noreferrer">{t("hos.hyperlink-text") as string}</a>.</p>
        </>
    );
}